import { render, staticRenderFns } from "./LogisticsHolidayTask.vue?vue&type=template&id=9cc1e48a&scoped=true"
import script from "./LogisticsHolidayTask.vue?vue&type=script&lang=js"
export * from "./LogisticsHolidayTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc1e48a",
  null
  
)

export default component.exports